__turbopack_context__.v({
  "area": "home-pricing-module__F0Aj_W__area",
  "autoTopup": "home-pricing-module__F0Aj_W__autoTopup",
  "axisLabel": "home-pricing-module__F0Aj_W__axisLabel",
  "axisTitle": "home-pricing-module__F0Aj_W__axisTitle",
  "baseKey": "home-pricing-module__F0Aj_W__baseKey",
  "baseLabel": "home-pricing-module__F0Aj_W__baseLabel",
  "bottom": "home-pricing-module__F0Aj_W__bottom",
  "controls": "home-pricing-module__F0Aj_W__controls",
  "cursor": "home-pricing-module__F0Aj_W__cursor",
  "description": "home-pricing-module__F0Aj_W__description",
  "details": "home-pricing-module__F0Aj_W__details",
  "equivalent": "home-pricing-module__F0Aj_W__equivalent",
  "estimate": "home-pricing-module__F0Aj_W__estimate",
  "graph": "home-pricing-module__F0Aj_W__graph",
  "graphKey": "home-pricing-module__F0Aj_W__graphKey",
  "gridLine": "home-pricing-module__F0Aj_W__gridLine",
  "heading": "home-pricing-module__F0Aj_W__heading",
  "line": "home-pricing-module__F0Aj_W__line",
  "links": "home-pricing-module__F0Aj_W__links",
  "operation": "home-pricing-module__F0Aj_W__operation",
  "point": "home-pricing-module__F0Aj_W__point",
  "presets": "home-pricing-module__F0Aj_W__presets",
  "projected": "home-pricing-module__F0Aj_W__projected",
  "rate": "home-pricing-module__F0Aj_W__rate",
  "rateAmount": "home-pricing-module__F0Aj_W__rateAmount",
  "rateUnit": "home-pricing-module__F0Aj_W__rateUnit",
  "rates": "home-pricing-module__F0Aj_W__rates",
  "saving": "home-pricing-module__F0Aj_W__saving",
  "section": "home-pricing-module__F0Aj_W__section",
  "selectedOperation": "home-pricing-module__F0Aj_W__selectedOperation",
  "shell": "home-pricing-module__F0Aj_W__shell",
  "slider": "home-pricing-module__F0Aj_W__slider",
  "total": "home-pricing-module__F0Aj_W__total",
  "volumeLabel": "home-pricing-module__F0Aj_W__volumeLabel",
});
